'use client'

import {
  Chrome,
  Fingerprint,
  KeyRound,
  ScanFace,
  SquareAsterisk,
} from 'lucide-react'
import Image from 'next/image'

import { BackendPasskey, OrgPasskey, OrgSigner } from '~/types'
import { isDarkMode } from '~/utils'
import { cn } from '~/utils/tailwind-utils'

export const SignerIcon = ({
  signer,
  highlighted,
  size = 20,
}: {
  signer: OrgSigner | OrgPasskey | BackendPasskey
  highlighted?: boolean
  size?: number
}) => {
  if (
    'providerIconDark' in signer &&
    'providerIconLight' in signer &&
    signer.providerIconDark &&
    signer.providerIconLight
  ) {
    const iconSvg = isDarkMode()
      ? signer.providerIconDark
      : signer.providerIconLight

    return (
      <Image
        src={iconSvg}
        alt={`Icon for ${signer.name}`}
        width={size}
        height={size}
      />
    )
  }

  const iconClasses = cn('flex-shrink-0', {
    'text-blue-500': highlighted,
  })
  const nameLowercase = signer.name!.toLowerCase()
  if (nameLowercase.includes('icloud')) {
    return <ScanFace size={size} className={iconClasses} />
  } else if (nameLowercase.includes('chrome')) {
    return <Chrome size={size} className={iconClasses} />
  } else if (nameLowercase.includes('yubi')) {
    return <SquareAsterisk size={size} className={iconClasses} />
  } else if (nameLowercase.includes('1p')) {
    return <KeyRound size={size} className={iconClasses} />
  } else {
    return <Fingerprint size={size} className={iconClasses} />
  }
}
